import './BookLayout.css'
import BookImage from './BookImage.jsx';
import Blurb from './Blurb.jsx';


function BookLayout({ book, last, blurbHtml, hasLink, blurbNoVanish, showBuyLinks }) {

   function tryParseJSONObject(jsonString) {
      try {
        var o = JSON.parse(jsonString);
    
        // Handle non-exception-throwing cases:
        // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
        // but... JSON.parse(null) returns null, and typeof null === "object", 
        // so we must check for that, too. Thankfully, null is falsey, so this suffices:
        if (o && typeof o === "object") {
          return o;
        }
      }
      catch (e) { }
    
      return false;
    };
    // console.log(book.linksToBuy);
  if (showBuyLinks && book.linksToBuy.length > 0) {
      
      let parsedLinks = tryParseJSONObject(book.linksToBuy);
      if (!parsedLinks) {
          parsedLinks = tryParseJSONObject(JSON.stringify(book.linksToBuy));
      }
      // console.log(parsedLinks)
      var links = parsedLinks.map((element) => {
          return (<form className="link-to-buy" action={element.link} target="_blank"><button className="link-btn" type="submit">{element.name.charAt(0).toUpperCase() + element.name.slice(1)}</button></form>)
      })
      // var coverArtLink = parsedLinks[0].link;
      // var linkDestinationName = book.linksToBuy[0].name;
      var hasLinkToBuy = true;
  }
  else {
      hasLinkToBuy = false;
  }

   return (
      <section className="book-layout">

         <div className="book-layout-contents">
			<BookImage book={book}/>
            <div className="book-text">
               {/* <h1 className="book-title">{bookName}</h1> */}
               {/* {subtitle && <h2 className='book-subtitle'>{subtitle}</h2>} */}
				<Blurb blurb={book.blurb} blurbNoVanish={blurbNoVanish} />
			 </div>


         </div>
         {hasLinkToBuy && <h2 className='link-to-buy-title'>Get a Copy</h2>}
            {links}
         {!last && <hr />}

      </section>
   );

}

export default BookLayout;
